export const ON_RECEIBE_CONFIRMATION = 'ON_RECEIBE_CONFIRMATION';
export const LOADING_TRANSACTION = 'LOADING_TRANSACTION';